<template>
  <v-dialog v-model="visible" max-width="1000">
    <v-card>
      <v-card-title class="text-h6 grey lighten-1">
         <v-avatar class="ml-n2 mr-3">
           <v-img :src="imagenTitulo" />
         </v-avatar>
         {{ objetoAparato.des }}
      </v-card-title>

      <v-card-text class="pa-0">
        <v-tabs v-model="tab" fixed-tabs background-color="#E0E0D0" mobile-breakpoint="0">
          <!-- <v-tabs-slider color="red"></v-tabs-slider> -->
          <v-tab>
            <v-icon class="mr-3">mdi-information-outline</v-icon>{{ $t ('General') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-comment-processing-outline</v-icon>{{ $t ('Eventos') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>

          <!-- G E N E R A L  -->

          <v-tab-item :eager="true">
            <v-container class="pt-8" fluid>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Identificación') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{ estadoAparato.machine_type == 5 ? $t ('Entrada') : estadoAparato.machine_type == 6 ? $t ('Salida') : estadoAparato.machine_type == 8 ? $t ('Paso') : '?' }} {{estadoAparato.machine_number}} ({{estadoAparato.short_name}})<br>
                  {{estadoAparato.long_name}}<br>
                </v-col>
              </v-row>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Versión') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{estadoAparato.version}}
                </v-col>
              </v-row>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Estado') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  <v-chip v-if="!estadoAparato.on_line" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-help-network</v-icon>{{$t ('Off line')}}</v-chip>
                  <v-chip v-if="estadoAparato.no_tickets_status" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-sim-off</v-icon>{{$t ('Sin tickets')}}</v-chip>
                  <v-chip v-if="estadoAparato.lpr_error" color="orange" outlined class="mr-1 mb-1"><v-icon left>mdi-camera-off</v-icon>{{$t ('Error cámara de matriculas')}}</v-chip>
                  <v-chip v-if="estadoAparato.barrier_status == 2" color="orange" outlined class="mr-1 mb-1"><v-icon left>mdi-arrow-up-bold</v-icon>{{$t ('Barrera bloqueada')}}</v-chip>
                  <v-chip v-if="estadoAparato.barrier_status == 3" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-boom-gate-alert</v-icon>{{$t ('Error de barrera')}}</v-chip>
                  <v-chip v-if="estadoAparato.out_of_order" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-close-octagon</v-icon>{{$t ('Fuera de servicio')}}</v-chip>

                  <v-chip v-if="estadoAparato.on_line && !estadoAparato.no_tickets_status && !estadoAparato.lpr_error && ![2,3].includes (estadoAparato.barrier_status) && !estadoAparato.out_of_order" color="green" outlined class="mr-1 mb-1"><v-icon left>mdi-emoticon-happy-outline</v-icon>{{$t ('Correcto')}}</v-chip>
                </v-col>
              </v-row>
              <v-row dense justify="center" v-if="estadoAparato.tickets_load_level < 9999">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Carga de tickets') }}:
                </v-col>
                <v-col cols="6">
                  <span style="font-family: monospace; font-weight: bolder">{{estadoAparato.tickets_load_level}}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- E V E N T O S  -->

          <v-tab-item :eager="true">
            <VisorEventosSAGA
              :key="objetoAparato.id_apa"
              :id-instalacion="objetoAparato.id_ins"
              :id-aparato="objetoAparato.id_apa"
              dense
              sin-sombra
            />
          </v-tab-item>

        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="visible = false">
          {{ $t ('Cerrar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VisorEventosSAGA from "@/components/VisorEventosSAGA.vue";

export default {
  components: { VisorEventosSAGA
              },
  data () {
    return {
      visible: false,
      tab: 0,
      objetoAparato: {},
      estadoAparato: {},
      sagabroker: null,
    }
  },
  computed: {
    imagenTitulo() {
      let ficheroImagen;
      if (this.estadoAparato.machine_type == 6)
        ficheroImagen = 'sal_dp0_db0_b0.png';
      else
        ficheroImagen = 'ent_dp0_db0_b0.png';
      return process.env.VUE_APP_URL_BASE_FRONTEND + 'assets__static/aparatos/' + ficheroImagen;
    }
  },
  methods: {
    abrirVentana (objetoAparato, estadoAparato, sagabroker) {
      //this.tab = 0;
      this.objetoAparato = objetoAparato;
      this.estadoAparato = estadoAparato;
      this.sagabroker = sagabroker;
      this.visible = true;
    },
  }
}
</script>

<style scoped>
.fuente-negrita {
  color: black;
  font-weight: bolder;
}
.tira-ultimas-operaciones {
  height: 350px;
  min-width: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #FFFFF0;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
</style>